module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('WebTemplate', {
    attrs: {
      "pagetitle": "新老访客",
      "tip": "新老访客报告帮助您查看您网站不同人群的流量分布、行为特征，从而对不同人群进行管理并优化营销策略",
      "currentTab": _vm.currentTab,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sum": _vm.sum,
      "order": _vm.order,
      "yAxis": _vm.yAxis,
      "legend": _vm.legend,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "tableUpdate": _vm.getTableData,
      "tablesorter": _vm.tablesorter
    }
  }, [_c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab,
      "currentTab": _vm.currentTab
    }
  }, [_c('div', {
    staticClass: "right-tab",
    slot: "extentTab"
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": "新老访客报表",
      "subtitle": ""
    }
  }) : _vm._e(), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('div', {
    slot: "common"
  }, [_c('p', {
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])])])])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e169d91c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e169d91c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/generation.vue
// module id = 805
// module chunks = 0